import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiputFormData } from "../../../API/Api_Url";

const SupplierRole = [
    "Brick / Block Supplier",
    "Steel Supplier",
    "Cement & Aggregate Vendor",
    "Sand & Gravel Supplier",
    "JCB / Excavation Contractor",
    "Water Tanker Supplier",
    "Lift Vendor",
];

function SupplierProfileUpdate({ ProUserdata, ChangeTab, GetUserProfile }) {
    const [isUploading, setIsUploading] = useState(false);
    const [companyName, setCompanyName] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [city, setCity] = useState("");
    const [location, setLocation] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [subRole, setSubRole] = useState("");

    const [materialTypesSupplied, setMaterialTypesSupplied] = useState("");
    const [brandsSupplied, setBrandsSupplied] = useState("");
    const [deliveryTime, setDeliveryTime] = useState("");
    const [accountHolderName, setAccountHolderName] = useState("");
    const [bankName, setBankName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [branchName, setBranchName] = useState("");
    const [upiId, setUpiId] = useState("");

    useEffect(() => {
        if (!ProUserdata) return;
        setCompanyName(ProUserdata.companyName || "");
        setContactPerson(ProUserdata.contactPerson || "");
        setEmailAddress(ProUserdata.emailAddress || "");
        setPhoneNumber(ProUserdata.phoneNumber || "");
        setCity(ProUserdata.City || "");
        setLocation(ProUserdata.Location || "");
        setCompanyAddress(ProUserdata.companyAddress || "");
        setSubRole(ProUserdata.SubRole || "");

        setMaterialTypesSupplied(
            ProUserdata.materialTypesSupplied?.join(", ") || ""
        );
        setBrandsSupplied(ProUserdata.brandsSupplied?.join(", ") || "");
        setDeliveryTime(ProUserdata.deliveryTimeForMaterials || "");

        setAccountHolderName(ProUserdata.Bankdetails?.AccountHolderName || "");
        setBankName(ProUserdata.Bankdetails?.BankName || "");
        setAccountNumber(ProUserdata.Bankdetails?.AccountNumber || "");
        setIfscCode(ProUserdata.Bankdetails?.IFSCCode || "");
        setBranchName(ProUserdata.Bankdetails?.BranchName || "");
        setUpiId(ProUserdata.Bankdetails?.UPIId || "");
    }, [ProUserdata]);

    const handleUpdateProfile = async () => {
        try {
            setIsUploading(true);

            const formData = new FormData();
            formData.append("companyName", companyName);
            formData.append("contactPerson", contactPerson);
            formData.append("emailAddress", emailAddress);
            formData.append("phoneNumber", phoneNumber);
            formData.append("City", city);
            formData.append("Location", location);
            formData.append("companyAddress", companyAddress);
            formData.append("SubRole", subRole);
            formData.append("materialTypesSupplied", materialTypesSupplied);
            formData.append("brandsSupplied", brandsSupplied);
            formData.append("deliveryTimeForMaterials", deliveryTime);
            formData.append("Bankdetails[AccountHolderName]", accountHolderName);
            formData.append("Bankdetails[BankName]", bankName);
            formData.append("Bankdetails[AccountNumber]", accountNumber);
            formData.append("Bankdetails[IFSCCode]", ifscCode);
            formData.append("Bankdetails[BranchName]", branchName);
            formData.append("Bankdetails[UPIId]", upiId);

            let response = await apiputFormData("api/material-supplier/update",formData);

            if (response?.data) {
                toast.success("Profile updated successfully!");
                GetUserProfile();
                ChangeTab("Profile");
            } else {
                toast.error(response?.message || "Failed to update profile");
            }
        } catch (err) {
            console.error("Update error:", err);
            toast.error("Error updating profile. See console for details.");
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="mx-auto space-y-6 p-4">
            <section className="bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                    Edit Supplier Profile
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField label="Company Name" value={companyName} setValue={setCompanyName} />
                    <InputField label="Contact Person" value={contactPerson} setValue={setContactPerson} />
                    <InputField label="Email Address" type="email" value={emailAddress} setValue={setEmailAddress} />
                    <InputField label="Mobile Number" type="tel" value={phoneNumber} setValue={setPhoneNumber} />
                    <InputField label="City" value={city} setValue={setCity} />
                    <InputField label="Location" value={location} setValue={setLocation} />
                    <InputField label="Company Address" value={companyAddress} setValue={setCompanyAddress} />

                    <div>
                        <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                            Sub Role
                        </label>
                        <select
                            value={subRole}
                            onChange={(e) => setSubRole(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="">Select Sub Role</option>
                            {SupplierRole.map((role, idx) => (
                                <option key={idx} value={role}>
                                    {role}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                    <InputField
                        label="Materials Supplied"
                        value={materialTypesSupplied}
                        setValue={setMaterialTypesSupplied}
                    />
                    <InputField
                        label="Brands Supplied"
                        value={brandsSupplied}
                        setValue={setBrandsSupplied}
                    />
                    <InputField
                        label="Delivery Time"
                        value={deliveryTime}
                        setValue={setDeliveryTime}
                    />
                </div>

                <h4 className="text-lg font-bold text-gray-700 mt-8 mb-4">
                    Bank Details
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField
                        label="Account Holder Name"
                        value={accountHolderName}
                        setValue={setAccountHolderName}
                    />
                    <InputField label="Bank Name" value={bankName} setValue={setBankName} />
                    <InputField
                        label="Account Number"
                        value={accountNumber}
                        setValue={setAccountNumber}
                    />
                    <InputField label="IFSC Code" value={ifscCode} setValue={setIfscCode} />
                    <InputField
                        label="Branch Name"
                        value={branchName}
                        setValue={setBranchName}
                    />
                    <InputField label="UPI ID" value={upiId} setValue={setUpiId} />
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200 flex gap-3 items-center">
                    <button
                        onClick={handleUpdateProfile}
                        disabled={isUploading}
                        className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                    >
                        {isUploading ? "Updating..." : "Save Changes"}
                    </button>

                    <button
                        onClick={() =>
                            typeof ChangeTab === "function" ? ChangeTab("Profile") : null
                        }
                        className="px-4 py-2 border rounded-lg"
                    >
                        Cancel
                    </button>
                </div>
            </section>
        </div>
    );
}

const InputField = ({ label, value, setValue, type = "text" }) => (
    <div>
        <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
            {label}
        </label>
        <input
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
    </div>
);

export default SupplierProfileUpdate;
